<template>
  <div class="row mb-2">
    <div class="col">
      <h4>{{ $trans.get("__JSON__.Bonuses") }}</h4>
    </div>
    <div class="col">
      <button class="btn btn-primary float-end" @click="addRate">
        {{ $trans.get("__JSON__.Add bonus") }}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <table class="table">
        <thead>
          <tr>
          <th>{{ $trans.get("__JSON__.Name") }}</th>
          <th>{{ $trans.get("__JSON__.Bonus profile") }}</th>
          <th>{{ $trans.get("__JSON__.Period") }}</th>
          <th>{{ $trans.get("__JSON__.Hours") }}</th>
          <th>{{ $trans.get("__JSON__.Timeframe") }}</th>
          <th>{{ $trans.get("__JSON__.Percentage") }}</th>
          <th class="w-10">{{ $trans.get("__JSON__.Actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bonus, index) in bonuses">
            <td>
              {{ bonus.name }}
            </td>
            <td>
              {{ bonus.profile?.name }}
            </td>
            <td>
              <span v-if="bonus.per_week">{{ $trans.get("__JSON__.Per week") }}</span>
              <span v-if="bonus.per_day">{{ $trans.get("__JSON__.Per day") }}</span>
              <span v-if="bonus.holiday">{{ $trans.get("__JSON__.Holiday") }}</span>
              &nbsp;
              <div v-if="bonus.day !== null && bonus.day >= 0">
                {{ $trans.get("__JSON__." + weekdays[bonus.day]) }}
              </div>
            </td>
            <td>{{ bonus.hours }}</td>
            <td>
              <span v-if="bonus.start_at">{{ bonus.start_at }} - {{ bonus.end_at }}</span>
            </td>
            <td>{{ bonus.percentage }} %</td>
            <td>
              <button class="btn btn-sm text-primary" @click="edit(index)">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-sm text-primary" @click="deleteBonus(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="bonusmodal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="bonustitle"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="row">

            <div class="mb-3">
              <label for="bonus_profile">{{ $trans.get("__JSON__.Bonus profile") }}</label>
              <select class="form-control" v-model="editbonus.employee_bonus_profile_id" id="bonus_profile">
                <option :value="null">{{ $trans.get("__JSON__.No bonus profile") }}</option>
                <option v-for="bonusprofile in bonusprofiles" :value="bonusprofile.id">{{ bonusprofile.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">

            <div class="mb-3">
              <label for="name">{{ $trans.get("__JSON__.Name") }}</label>
              <input type="text" class="form-control" v-model="editbonus.name" id="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <input type="checkbox" v-model="editbonus.per_day" id="per_day" @click="change" />
              <label for="per_day" id="per_day">{{ $trans.get("__JSON__.Per day") }}</label>
            </div>

            <div class="col-4">
              <input type="checkbox" v-model="editbonus.per_week" id="per_week" @click="change" />
              <label for="per_week" id="per_week">{{ $trans.get("__JSON__.Per week") }}</label>
            </div>

            <div class="col-4">
              <input type="checkbox" v-model="editbonus.holiday" id="holiday" @click="change" />
              <label for="holiday" id="holiday">{{ $trans.get("__JSON__.Holiday") }}</label>
            </div>
          </div>

          <span v-if="errors['day']">
            <span v-for="error in errors['day']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="row mb-2">
            <div class="col">
              <label for="day">{{ $trans.get("__JSON__.Day") }}</label>
              <select name="day" id="day" v-model="editbonus.day" class="form-control">
                <option value="-1">{{ $trans.get("__JSON__.No day") }}</option>
                <option v-for="(weekday, index) in weekdays" :value="index">
                  {{ $trans.get("__JSON__." + weekday) }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <span v-if="errors['start_at']">
              <span v-for="error in errors['start_at']" class="text-danger">
                {{ error }}
              </span>
            </span>
            <span v-if="errors['end_at']">
              <span v-for="error in errors['end_at']" class="text-danger">
                {{ error }}
              </span>
            </span>

            <div class="col-6">
              <label for="start_at">{{ $trans.get("__JSON__.Start") }}</label>
              <input id="start_at" type="time" class="form-control" v-model="editbonus.start_at" />
            </div>

            <div class="col-6">
              <label for="end_at">{{ $trans.get("__JSON__.End") }}</label>
              <input id="end_at" type="time" class="form-control" v-model="editbonus.end_at" />
            </div>
          </div>

          <span v-if="errors['hours']">
            <span v-for="error in errors['hours']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="mb-3">
            <label for="hours">{{ $trans.get("__JSON__.Hours") }} (0=Soll-Arbeitszeit)</label>
            <input id="hours" type="numeric" step="0.01" class="form-control" v-model="editbonus.hours" />
          </div>

          <span v-if="errors['percentage']">
            <span v-for="error in errors['percentage']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="mb-3">
            <label for="percentage">{{ $trans.get("__JSON__.Percentage") }}</label>
            <input id="percentage" type="numeric" step="0.01" class="form-control" v-model="editbonus.percentage" />
          </div>


          <div class="row">
            <div class="col-6 mb-3">
              <label for="wage_type_id">{{ $trans.get("__JSON__.Wage type bonus") }}</label>
              <select name="wage_type_id" id="wage_type_id" v-model="editbonus.wage_type_id" class="form-control">
                <option value="0">{{ $trans.get("__JSON__.No wage type") }}</option>
                <option v-for="wageType in wageTypes" :value="wageType.id">
                  {{ wageType.description }}
                </option>
              </select>
            </div>
            <div class="col-6 mb-3">
              <label for="hours_wage_type_id">{{ $trans.get("__JSON__.Wage type hours") }}</label>
              <select name="hours_wage_type_id" id="hours_wage_type_id" v-model="editbonus.hours_wage_type_id" class="form-control">
                <option value="0">{{ $trans.get("__JSON__.No wage type") }}</option>
                <option v-for="wageType in wageTypes" :value="wageType.id">
                  {{ wageType.description }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $trans.get("__JSON__.Close") }}
          </button>
          <button type="button" class="btn btn-primary" @click="save">
            {{ $trans.get("__JSON__.Save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EmployeeRateBonuses",
  created() { },
  props: {
    employer_id: null,
  },
  data() {
    return {
      bonuses: null,
      bonusprofiles: null,
      wageTypes: null,
      editbonus: {
        id: null,
        percentage: null,
        hours: null,
        start_at: null,
        end_at: null,
        per_week: null,
        per_day: null,
        day: null,
        holiday: null,
        employee_bonus_profile_id: null,
        employer_id: this.employer_id,
        wage_type_id: 0,
        hours_wage_type_id: 0
      },
      errors: [],
      weekdays: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ],
    };
  },
  watch: {},
  mounted() {
    this.fetchBonusProfiles();
    this.fetchBonuses();
    this.fetchWageTypes();
  },
  methods: {
    addRate() {
      this.editbonus = {
        id: null,
        percentage: null,
        hours: null,
        start_at: null,
        end_at: null,
        per_week: false,
        per_day: false,
        holiday: false,
        day: -1,
        employee_bonus_profile_id: null,
        employer_id: this.employer_id,
        wage_type_id: 0,
        hours_wage_type_id: 0,
      };
      this.errors = [];
      $("#bonustitle").html(this.$trans.get("__JSON__.Create employer bonus"));
      $("#bonusmodal").modal("show");
    },
    edit(index) {
      this.editbonus = this.bonuses[index];
      if (this.editbonus.per_week == 1) {
        this.editbonus.per_week = true;
      }
      if (this.editbonus.per_day == 1) {
        this.editbonus.per_week = true;
      }
      if (this.editbonus.per_holiday == 1) {
        this.editbonus.per_week = true;
      }

      this.editbonus = this.editbonus ?? 0;

      $("#bonustitle").html(this.$trans.get("__JSON__.Edit employer bonus"));
      $("#bonusmodal").modal("show");
    },
    deleteBonus(index) {
      if (confirm("Are you sure you want to delete the employer bonus?")) {
        axios
          .delete("/api/employerratebonuses/" + this.bonuses[index].id)
          .then((resp) => {
            self.errors = [];
            this.fetchBonuses();
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      }
    },
    save() {
      if (this.editbonus.id != null) {
        axios
          .put("/api/employerratebonuses/" + this.editbonus.id, this.editbonus)
          .then((resp) => {
            self.errors = [];
            this.fetchBonuses();
            $("#bonusmodal").modal("hide");
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } else {
        axios
          .post("/api/employerratebonuses", this.editbonus)
          .then((resp) => {
            self.errors = [];
            this.fetchBonuses();
            $("#bonusmodal").modal("hide");
          })
          .catch((error) => {
            console.log(error.response.data);
            this.errors = error.response.data.errors;
          });
      }
    },
    fetchBonuses() {
      axios
        .get("/api/employerratebonuses", {
          params: {
            employer_id: this.employer_id,
          },
        })
        .then((resp) => {
          console.log(resp.data);
          this.bonuses = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchBonusProfiles() {
      axios
        .get("/api/employeebonusprofiles", {
          params: {
            employer_id: this.employer_id,
          },
        })
        .then((resp) => {
          console.log(resp.data);
          this.bonusprofiles = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchWageTypes() {
      axios
        .get("/api/wagetypes", {
          params: {
          },
        })
        .then((resp) => {
          this.wageTypes = resp.data;
          console.log(this.wageTypes);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    change(event) {
      if ($(event.target).is(":checked")) {
        const checkId = $(event.target).attr("id");
        const checks = ["per_day", "per_week", "holiday"];

        checks.forEach(function (check) {
          if (checkId != check) {
            $("#" + check).prop("checked", false);
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
